import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import CompanyCard from './CompanyCard';
import GridListTile from '@material-ui/core/GridListTile';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles(theme => ({
  root: {
    margin: {
      top: 20,
    },
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    //    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: '100%',
    //    height: 450,
  },
}));

export default function CompanyGridList(props) {
  const classes = useStyles();
  const isSM = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const isMD = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (
    <div className={classes.root}>
      <GridList cellHeight={380} className={classes.gridList} cols={isMD ? 3 : ( isSM ? 2 : 1 )}>
        {props.items.map(company => (
          <GridListTile key={company.id} cols={1}>
            <CompanyCard company={company}
              click={props.click}
              chatClick={props.chatClick}
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}
